import saveDesignersKlaviyo from "./saveDesignersKlaviyo";
import saveDesignersCustomer from "./saveDesignersCustomer";
import customerReady from "./customerReady";

let queue = Promise.resolve();

let currentRequestId = 0;

class UpdateDesigners {
  constructor() {
    this.getData = new Promise(resolve => {
      customerReady.then(() => {
        const followDesigners = CF.customer.get('follow_designers');

        const handles = followDesigners ? followDesigners.map(({ handle }) => handle) : [];

        this.followDesigners = new Set(handles);
        resolve();
      });
    });
  }

  _update(designerHandle, action) {
    return this.getData.then(() => {
      if (action === 'remove') {
        this.followDesigners.delete(designerHandle);
      } else {
        this.followDesigners.add(designerHandle);
      }

      const requestId = currentRequestId;

      document.dispatchEvent(new CustomEvent('follow-designers:updated', { detail: { followDesigners: [...this.followDesigners] } }));

      queue = queue.then(() => {
        // Newer update pending
        if (requestId !== currentRequestId) return Promise.resolve();

        const followDesigners = [...this.followDesigners];
        return Promise.all([
          saveDesignersCustomer(followDesigners),
          saveDesignersKlaviyo(followDesigners),
        ]);
      });

      return queue;
    });
  }

  add(designerHandle) {
    return this._update(designerHandle, 'add');
  }

  remove(designerHandle) {
    return this._update(designerHandle, 'remove');
  }

  has(designerHandle) {
    return this.getData.then(() => this.followDesigners.has(designerHandle));
  }
}

export default new UpdateDesigners;
